// src/state/deviceState.js

function getOrientation(w, h) {
  return w >= h ? "landscape" : "portrait";
}

function getDeviceTypeByWidth(w) {
  // 필요하면 기준 바꿔도 됨
  if (w <= 767) return "mobile";
  if (w <= 1023) return "tablet";
  return "desktop";
}

export function readDeviceSnapshot() {
  if (typeof window === "undefined") {
    return {
      deviceType: "desktop",
      viewport: { width: 0, height: 0 },
      dpr: 1,
      orientation: "landscape",
      ua: "",
      platform: "",
      isTouch: false,
    };
  }

  const w = window.innerWidth || 0;
  const h = window.innerHeight || 0;
  const dpr = window.devicePixelRatio || 1;

  const ua = typeof navigator !== "undefined" ? navigator.userAgent || "" : "";
  const platform =
    typeof navigator !== "undefined" ? navigator.platform || "" : "";

  const isTouch =
    typeof window !== "undefined" &&
    ("ontouchstart" in window ||
      (typeof navigator !== "undefined" && navigator.maxTouchPoints > 0));

  return {
    deviceType: getDeviceTypeByWidth(w),
    viewport: { width: w, height: h },
    dpr,
    orientation: getOrientation(w, h),
    ua,
    platform,
    isTouch,
  };
}

export function deviceReducer(state, action) {
  switch (action.type) {
    case "DEVICE/REFRESH": {
      return { ...state, ...action.payload };
    }
    default:
      return state;
  }
}
